// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DAd8","importantInfo":"styles_importantInfo__34DvA"};